import { subscribe } from '../../errors/sagas';
import { notificationError } from '../../errors/notificationTypes';

const pre = 'COMMON/DOWNLOADCRIF/';

export const DOWNLOAD_CRIF_REQUESTED = `${pre}DOWNLOAD_CRIF_REQUESTED`;
export const DOWNLOAD_CRIF_SUCCEEDED = `${pre}DOWNLOAD_CRIF_SUCCEEDED`;
export const DOWNLOAD_CRIF_FAILED = `${pre}DOWNLOAD_CRIF_FAILED`;

subscribe(DOWNLOAD_CRIF_FAILED, 'Download CRIF Failed', notificationError);

export const downloadCrifRequested = (date, csa) => ({
    type: DOWNLOAD_CRIF_REQUESTED,
    date,
    csa
});

export const downloadCrifSucceeded = (date, csa, response) => ({
    type: DOWNLOAD_CRIF_SUCCEEDED,
    date,
    csa,
    response
});

export const downloadCrifFailed = error => ({
    type: DOWNLOAD_CRIF_FAILED,
    error
});
